import dynamic from "next/dynamic"
import lottieResource from "@/assets/lottie/loading.json"

// 💡 동적으로 import하고 SSR을 비활성화
const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const LoadingIndicator = () => {
  return (
    <>
      <Lottie
        animationData={lottieResource}
        loop={true}
        style={{ width: 56, height: 56 }}
      />
    </>
  )
}

export default LoadingIndicator
